export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';
/**
 * What a suspended person is told.
 *
 * Plain and final. No reason, because the reason is between them and Caren and
 * does not belong in a login form; no "contact support to restore access",
 * because that reads as a retry and invites a loop of attempts against a
 * decision that has already been made. One sentence, and it is the same
 * sentence whether they hit it at login, on a page load, or on a reset link.
 */
export const SUSPENDED_ERR_MSG = 'This account has been suspended.';
